import { render, staticRenderFns } from "./Tag-InOut.vue?vue&type=template&id=08518a0e&"
import script from "./Tag-InOut.vue?vue&type=script&lang=ts&"
export * from "./Tag-InOut.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports